module.exports = __webpack_public_path__ + "img/trendsetter.cc909fb8.gif";